import { render, staticRenderFns } from "./importBJOrdersExcel.vue?vue&type=template&id=3a60c542&scoped=true&"
import script from "./importBJOrdersExcel.vue?vue&type=script&lang=js&"
export * from "./importBJOrdersExcel.vue?vue&type=script&lang=js&"
import style0 from "./importBJOrdersExcel.vue?vue&type=style&index=0&id=3a60c542&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60c542",
  null
  
)

component.options.__file = "importBJOrdersExcel.vue"
export default component.exports